import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"left"} }, "Checks", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"left"} }, "Products", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"left"} }, "Details", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content is-small", { 'has-background-black': _ctx.isDark }])
  }, [
    _createElementVNode("h1", _hoisted_1, "Order " + _toDisplayString(_ctx.id), 1),
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark }),
      innerHTML: _ctx.checksTable
    }, null, 10, _hoisted_3),
    _hoisted_4,
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark }),
      innerHTML: _ctx.productsTable
    }, null, 10, _hoisted_5),
    _hoisted_6,
    _createElementVNode("pre", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark }),
      style: {"text-align":"left"}
    }, _toDisplayString(_ctx.listing), 3)
  ], 2))
}